export default class Dev {
  constructor(Vue) {
    this.company = Vue.prototype.$company;
    this.user = Vue.prototype.$user;
    this.portal = Vue.prototype.$portal;
    this.currentModule = Vue.prototype.$currentModule;
  }

  loadScriptHead(arg) {
    return new Promise((resolve, reject) => {
      let script = document.createElement("script");
      script.id = 'customScript';

      if (!arg && !arg.body) {
        console.log(arg);
        return reject('#ERRO_SCRIPT_DOWNLOAD_BODY');
      }

      if (arg.body) script.innerHTML = arg.body;
      else script.innerHTML = arg;

      document.head.appendChild(script);
      try {
        if (_.isFunction(customScriptRun)) customScriptRun();
      } catch (err) {
        return reject(err);
      }

      return resolve()
    })
  }

  clearOldScript() {
    return new Promise((resolve, reject) => {
      try {
        $('#customScript').remove();
      } catch (err) { }
      try {
        $('#html-sd').empty();
      } catch (err) { }
      try {
        if (customScriptRun) customScriptRun = null;
      } catch (err) { }
      try {
        if (customScriptGetTemplate) customScriptGetTemplate = null;
      } catch (err) { }
      return resolve();
    });
  }

  createDocumentPortability(result) {
    return new Promise((resolve, reject) => {
      const script = _.get(this.company, 'itemOpen.script', '').replace(/\.(js|vue)$/, '');

      this.currentModule.detailSqlResult = result.rows;

      document[script] = result.rows;

      document[`${script}-obj`] = {
        company: {
          id: this.company.json.id,
          module: this.company.json.module,
          phone: this.company.json.phone,
        },
        companyId: this.company.json.id,
        customValue: this.company.moduleOpen.customValue,
        detailSql: this.company.itemOpen.detailSql,
        endPointUrl: this.portal.url.endPoint.core,
        session: this.user.token,
        user: this.user.json,
        userEmail: this.user.json.email,
        connectorId: this.company.itemOpen.connector,
      };

      return resolve();
    });
  }

  createCurrentModulePortability() {
    return new Promise((resolve, reject) => {
      this.currentModule.module = this.company.moduleOpen;
      this.currentModule.item = this.company.itemOpen;
      return resolve();
    })
  }

  async reloadDataModule(id) {
    await this.company.reloadJson();
    this.currentModule.module = this.company.json.module.find(module => module.id === id);
  }

  checkResultSql(result) {
    return new Promise((resolve, reject) => {
      if (!result || !result.rows || !_.isArray(result.rows)) return reject('#ERRO_RESULT_SQL');
      return resolve(result);
    });
  }
}
